import { AccountStates } from '@generated/graphql';
import type { DraftAccount } from '@interfaces/account';
import type { Goal } from '@interfaces/goalSubAccountTypes';
import type { User } from '@interfaces/user';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import type { AccountTypes } from '@onevesthq/ov-enums';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Form } from '@ovComponents/2-component/form/form';
import { Box, Button, Typography } from 'hephaestus/web';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoalLinkingInput, getValidGoals } from '../goalLinking';

export const AccountDialogContent = ({
  accountType,
  userData,
  onAccountCreated,
  onDialogClose,
}: {
  accountType: AccountTypes;
  userData: User;
  showGoalLinkingSection: boolean;
  onAccountCreated: (account: DraftAccount) => void;
  onDialogClose: () => void;
}) => {
  const { t } = useTranslation(['accountTypes', 'workflowCompletions']);
  const [goalsLinked, setGoalsLinked] = useState<Goal[]>([]);
  const goals = getValidGoals(userData);
  const submit = () => {
    onAccountCreated({
      type: accountType,
      applyForGovFunds: [],
      id: '',
      state: AccountStates.Active,
      user: userData,
      goalsLinked,
    });
  };

  return (
    <Form onSubmit={submit}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'end',
        }}
      >
        <Box
          onClick={onDialogClose}
          sx={{
            display: 'flex',
            cursor: 'pointer',
          }}
        >
          <Icon icon={CloseRoundedIcon} size='medium' />
        </Box>
      </Box>
      <Typography variant='headingMedium' sx={{ mt: 1 }}>
        {t(`accountTypes:${accountType}`)}
      </Typography>
      <Box sx={{ mt: 4 }}>
        <GoalLinkingInput
          goals={goals}
          goalsLinked={goalsLinked}
          setGoalsLinked={setGoalsLinked}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        <Button color='primary' disabled={false} sx={{ mt: 3 }} type='submit'>
          {t('workflowCompletions:baseAccountCreation.addAccount')}
        </Button>
      </Box>
    </Form>
  );
};
